import { render, staticRenderFns } from "./PermissionsProjectFoldersForm.vue?vue&type=template&id=5c4ab9da&scoped=true&"
import script from "./PermissionsProjectFoldersForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsProjectFoldersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ab9da",
  null
  
)

export default component.exports